<template>
  <div class="app-dashboard">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Moyenne de traitement">
          <template slot="no-body">
            <div style="height: 354px">
              <template slot="actions">
                <small><span>Derniers 30 jours</span></small>
              </template>

              <div slot="no-body">
                <!-- CHART -->

                <vue-apex-charts
                  type="pie"
                  height="234"
                  class=""
                  :options="timeCharts.options"
                  :series="timeCharts.series"
                />

                <ul class="mb-1">
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="
                          inline-block
                          h-3
                          w-3
                          rounded-full
                          mr-2
                          bg-primary
                        "
                      />
                      <span class="font-semibold">= au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_equal }} </span>
                  </li>
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="inline-block h-3 w-3 rounded-full mr-2 bg-danger"
                      />
                      <span class="font-semibold">> au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_superior }} </span>
                  </li>
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="
                          inline-block
                          h-3
                          w-3
                          rounded-full
                          mr-2
                          bg-success
                        "
                      />
                      <span class="font-semibold"> &lt; au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_inferior }} </span>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-base" v-if="top_agents.length">
        <vx-card title="Top agents">
          <template slot="no-body">
            <div style="height: 354px">
              <template slot="actions">
                <small><span>Derniers 30 jours</span></small>
              </template>
              <div slot="no-body">
                <div class="text-center my-8">
                  <vs-avatar
                    v-if="top_agents[0].photo"
                    size="100px"
                    class="mb-2"
                    :src="top_agents[0].photo"
                  />
                  <vs-avatar
                    v-else
                    size="100px"
                    class="mb-2"
                    :src="
                      require('@/assets/images/portrait/small/avatar-s-13.jpg')
                    "
                  />
                  <h5 class="text-bold">{{ top_agents[0].name }}</h5>
                  <span>{{ top_agents[0].total_request }} demandes</span>
                </div>
                <ul>
                  <li
                    class="
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <div class="flex justify-between">
                      <span>
                        {{ top_agents[0].name }}
                      </span>
                      <span>{{ top_agents[0].total_request }}</span>
                    </div>
                    <vs-progress
                      class="block mt-1"
                      :percent="top_agents[0].percent"
                      color="primary"
                    />
                  </li>
                  <li
                    v-if="top_agents[1]"
                    class="
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <div class="flex justify-between">
                      <span>
                        {{ top_agents[1].name }}
                      </span>
                      <span>{{ top_agents[1].total_request }}</span>
                    </div>
                    <vs-progress
                      class="block mt-1"
                      :percent="top_agents[1].percent"
                      color="primary"
                    />
                  </li>
                  <li
                    v-if="top_agents[2]"
                    class="
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <div class="flex justify-between">
                      <span>
                        {{ top_agents[2].name }}
                      </span>
                      <span>{{ top_agents[2].total_request }}</span>
                    </div>
                    <vs-progress
                      class="block mt-1"
                      :percent="top_agents[2].percent"
                      color="primary"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-base" v-if="approvalDatas.length">
        <vx-card title="Approbations">
          <template slot="no-body">
            <div style="height: 375px">
              <VuePerfectScrollbar
                ref="chatLogPS"
                class="scroll-area pt-6 px-6"
                :settings="settings"
                key="eeee"
              >
                <ul class="vx-timeline">
                  <li v-for="item in approvalDatas" :key="item.id">
                    <div class="timeline-icon bg-grey">
                      <feather-icon
                        :icon="item.icon"
                        svgClasses="text-white stroke-current w-5 h-5"
                      />
                    </div>
                    <div
                      class="
                        timeline-info
                        flex
                        justify-between
                        items-center
                        px-2
                        py-3
                        shadow-drop
                        rounded-lg
                      "
                    >
                      <div class="">
                        <h6 class="mb-2">{{ item.chain_name }}</h6>
                        <div class="activity-desc">
                          <span class="block">{{ item.title }}</span>
                          <span>Client : {{ item.social_reason }}</span>
                        </div>
                        <div class="">
                          <vs-button type="flat" size="small"
                            >Détails</vs-button
                          >
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
            </div>
          </template>
        </vx-card>
      </div>
    </div>

    <br />

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Demandes dont le SLA arrive à terme">
          <div slot="no-body" class="mt-4">
            <vs-table :data="slaEndRequests" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>DEMANDE</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>PRIORITÉ</vs-th>
                <vs-th>STATUT</vs-th>
                <vs-th>DATE DE CREATION</vs-th>
                <vs-th>ACTIONS</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{ data[indextr].title }}</span>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.type }}</span></vs-td
                  >
                  <vs-td>
                    <vs-chip :color="getPriorityColor(tr.priority)">{{
                      tr.priority
                    }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-chip>{{ tr.status }}</vs-chip>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.created_at }}</span></vs-td
                  >
                  <vs-td class="whitespace-no-wrap">
                    <div class="flex">
                      <div
                        @click="goToSingle(tr.id, tr.has_proved)"
                        class="flex"
                      >
                        <feather-icon
                          icon="EyeIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          class="mr-2"
                        />
                        Détails
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
var base_self;
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";

export default {
  components: { VueApexCharts, VuePerfectScrollbar },
  data() {
    return {
      last_page: 1,
      page: 1,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      top_agents: [],
      affiche_average: {
        sla_equal: 0,
        sla_inferior: 0,
        sla_superior: 0,
      },
      affiche: {
        per: 0,
        totalBills: 0,
        totalBillsRecovered: 0,
        //  *********************
        requestTotal: 0,
        requestTotalEnd: 0,
        requestTotalOnTreat: 0,
        requestTotalReject: 0,
        requestTotalTreat: 0,
      },
      timeCharts: {
        options: {
          labels: [
            "= temps recommandé",
            "< au temps recommandé",
            "> au temps recommandé",
          ],
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          chart: {
            type: "pie",
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            width: 5,
          },
          colors: ["#077a30", "#29c76f", "#EA5455"],
        },
        series: [0, 0, 0],
        // series: []
      },
      approvalDatas: [],
      notAssignedRequests: [],
      slaEndRequests: [],
    };
  },
  methods: {
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(2000);
    },
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    getProgressionColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    async get_dashboard_manager_request_stats() {
      let response =
        await base_self.$store.state.dashboard_manager_request_stats({});

      base_self.affiche.requestTotal = response.data.requestTotal;
      base_self.affiche.requestTotalEnd = response.data.requestTotalEnd;
      base_self.affiche.requestTotalOnTreat = response.data.requestTotalOnTreat;
      base_self.affiche.requestTotalReject = response.data.requestTotalReject;
      base_self.affiche.requestTotalTreat = response.data.requestTotalTreat;
    },
    async get_dashboard_manager_bills() {
      let response = await base_self.$store.state.dashboard_manager_bills({});

      base_self.affiche.per = response.data.per;
      base_self.affiche.totalBills = response.data.totalBills;
      base_self.affiche.totalBillsRecovered = response.data.totalBillsRecovered;
    },
    async get_dashboard_manager_requests_not_assign(page) {
      let response = await base_self.$store.state
        .requests_not_approved({}, { page })
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.last_page = response.data.last_page;
      base_self.notAssignedRequests = response.data.data;
      // console.log('dashboard_manager_requests_not_assign -- response.data: ', response.data);
    },
    async get_dashboard_manager_approbation() {
      let response = await base_self.$store.state.dashboard_manager_approbation(
        {}
      );

      var array = response.data;
      var length = array.length;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        array[iuoy].color = "primary";
        array[iuoy].icon = "CheckIcon";
      }
      base_self.approvalDatas = array;
      // console.log('dashboard_manager_approbation -- response.data: ', response.data);
    },
    async get_dashboard_manager_average_treatment() {
      let response =
        await base_self.$store.state.dashboard_manager_average_treatment({});

      base_self.affiche_average.sla_equal = response.data.sla_equal;
      base_self.affiche_average.sla_inferior = response.data.sla_inferior;
      base_self.affiche_average.sla_superior = response.data.sla_superior;

      var series = [];
      series.push(response.data.sla_equal);
      series.push(response.data.sla_inferior);
      series.push(response.data.sla_superior);

      base_self.timeCharts.series = JSON.parse(JSON.stringify(series));
    },
    async get_dashboard_manager_top_agent() {
      let response = await base_self.$store.state.dashboard_manager_top_agent(
        {}
      );

      var array = response.data;
      var length = array.length;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = array[iuoy];

        var percent =
          (((item.sla_inferior - item.sla_superior) * 50) / 100 +
            (item.total_request * 40) / 100 +
            (item.sla_equal * 10) / 100) /
          3;
        array[iuoy].percent = percent;
      }
      /*
        id:
        owner:
        name:
        total_request:
        sla_inferior:
        sla_equal:
        sla_superior:
        photo:
        */
      array.sort(function (a, b) {
        if (b.percent < a.percent) {
          return 1;
        }
        if (b.percent > a.percent) {
          return -1;
        }
        return 0;
      });
      base_self.top_agents = array;
      // console.log('dashboard_manager_top_agent -- response.data: ', response.data);
    },
    async get_dashboard_admin_sla_end_request() {
      this.$http
        .get("/dashboard/manager/request-sla-end", {})
        .then((response) => {
          if (response.data) {
            this.slaEndRequests = response.data;
          }
        })
        .catch((error) => {
          error.response.status === 401
            ? window.GETCCMT.$router.push("/login")
            : console.log("error: ", error);
        });
    },
  },
  mounted() {
    base_self.get_dashboard_manager_request_stats();
    base_self.get_dashboard_manager_bills();
    base_self.get_dashboard_manager_approbation();
    base_self.get_dashboard_manager_average_treatment();
    base_self.get_dashboard_manager_top_agent();

    base_self.get_dashboard_admin_sla_end_request();
    base_self.get_dashboard_manager_requests_not_assign(base_self.page);
  },
  created() {
    base_self = this;
    window.ManagerDashboardApp = this;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>
